module.exports = __webpack_public_path__ + "static/img/bonus_1.3c2d01e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dhlw/bonus_1.png
// module id = 6mKW
// module chunks = 0